import React, { useState, useEffect, useRef } from 'react';
import Plaintext from './plaintext';
import Text from './text';
import Helpers from 'utils/helpers';
import _ from 'lodash';

export default function TextInputThrottledWrapper(props) {
  if (props.plaintext || props.readOnly || props.readonly || props.disabled) {
    return (
      <Plaintext style={props.style}>
        {Helpers.Object.exists(props.value) ? props.value : props.defaultValue}
      </Plaintext>
    );
  }
  else {
    return <TextInputThrottled {...props} />;
  }
}

function TextInputThrottled(props) {
  const { onChange, onValueChange, onBlur, value, defaultValue, debounceDelay, ...childProps } = props;

  const [displayValue, setDisplayValue] = useState('');
  const debounceDelayTime = debounceDelay ? debounceDelay : 500;
  const isUpdateOnBlur = false;

  useEffect(() => {
    setDisplayValue(value || defaultValue);
  }, [value, defaultValue]);

  const dispatchDebounced = useRef(
    _.debounce((event) => {
      if (onChange) {
        onChange(event);
      }
      if (onValueChange) {
        onValueChange(event.target.value, { revertChange });
      }
    }, debounceDelayTime)
  ).current;

  const handleChange = (event) => {
    setDisplayValue(event.target.value);
    if (isUpdateOnBlur) {
      return;
    }
    const syntheticEvent = { ...event };
    dispatchDebounced(syntheticEvent);
  };

  const handleBlur = (event) => {
    if (isUpdateOnBlur) {
      if (onChange) {
        const syntheticEvent = {
          target: {
            value: displayValue,
          },
        };
        onChange(syntheticEvent);
      }
      if (onValueChange) {
        onValueChange(displayValue, { revertChange });
      }
    }
    if (onBlur) {
      onBlur(event);
    }
  };

  const revertChange = () => {
    setDisplayValue(value);
  };

  return (
    <Text
      {...childProps}
      value={displayValue || ''}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
}